import RenameLookalikeAudienceModal from './RenameLookalikeAudienceModal.Container';

export default RenameLookalikeAudienceModal;
